document.addEventListener("DOMContentLoaded", function() {
  const el = document.querySelector(".b2b-shipping-accordion");
  if (!el) return;

  const toggleBtn = document.getElementById("b2b-accordion-toggle");
  const contentBox = document.getElementById("b2b-accordion-content");
  const iconSpan = document.getElementById("b2b-accordion-icon");

  if (toggleBtn && contentBox) {
    toggleBtn.addEventListener("click", function() {
      if (contentBox.style.maxHeight !== "" && contentBox.style.maxHeight !== "0px") {
        contentBox.style.maxHeight = "0px";
        iconSpan.innerText = "+";
        toggleBtn.style.background = "#EEF1F9";
      } else {
        contentBox.style.maxHeight = contentBox.scrollHeight + "px";
        iconSpan.innerText = "−";
        toggleBtn.style.background = "#dde3f5";
      }
    });
  }

  const countryCode = el.dataset.country;
  const countryName = el.dataset.countryName;
  const freeLabel = el.dataset.freeShipping;
  const hazardMsg = el.dataset.hazard;

  const geoName = document.getElementById("geo-country-name");
  if (geoName) geoName.innerText = countryName;

  function fmt(type, rateText) {
    if (type === "free") return "<span style='color:#1a7a3c;font-weight:600;'>" + freeLabel + "</span>";
    return "+ " + rateText + " Carriage";
  }

  const zoneCoreEuro   = ["DE","NL","BE","LU"];
  const zoneMidEuro    = ["FR","MC","DK", "AT"];
  const zoneWestEuro   = ["IE","IT"];
  const zoneNordicEuro = ["SE","FI"];
  const zoneEastEuro   = ["CZ","PL"];
  const zoneSouthEast  = ["PT","SI","SK","RO","BG","EE","LV","LT"];
  const zonePeriphery  = ["GR","AD","SM","LI"];
  const zoneIslands    = ["MT","CY","GI"];

  const t1  = document.getElementById("geo-tier-1");
  const t2  = document.getElementById("geo-tier-2");
  const t4  = document.getElementById("geo-tier-4");
  const t12 = document.getElementById("geo-tier-12");

  if (zoneIslands.includes(countryCode)) {
    const table = document.getElementById("b2b-tiers-table");
    if (table) table.style.display = "none";
    if (contentBox) {
      contentBox.innerHTML = "<div style='padding:15px;color:#d9534f;'>" + hazardMsg + "</div>";
      contentBox.style.maxHeight = "200px";
    }
    if (iconSpan) iconSpan.innerText = "−";

  } else if (zoneCoreEuro.includes(countryCode)) {
    t1.innerHTML  = fmt("cost", "€7.95");
    t2.innerHTML  = fmt("cost", "€4.95");
    t4.innerHTML  = fmt("free");
    t12.innerHTML = fmt("free");

  } else if (zoneMidEuro.includes(countryCode)) {
    t1.innerHTML  = fmt("cost", "€9.95");
    t2.innerHTML  = fmt("cost", "€5.95");
    t4.innerHTML  = fmt("free");
    t12.innerHTML = fmt("free");

  } else if (zoneWestEuro.includes(countryCode)) {
    t1.innerHTML  = fmt("cost", "€19.95");
    t2.innerHTML  = fmt("cost", "€14.95");
    t4.innerHTML  = fmt("cost", "€9.95");
    t12.innerHTML = fmt("free");

  } else if (countryCode === "ES") {
    t1.innerHTML  = fmt("cost", "€29.95");
    t2.innerHTML  = fmt("cost", "€21.95");
    t4.innerHTML  = fmt("cost", "€16.95");
    t12.innerHTML = fmt("free");

  } else if (zoneNordicEuro.includes(countryCode)) {
    t1.innerHTML  = fmt("cost", "€29.95");
    t2.innerHTML  = fmt("cost", "€19.95");
    t4.innerHTML  = fmt("cost", "€14.95");
    t12.innerHTML = fmt("free");

  } else if (zoneEastEuro.includes(countryCode)) {
    t1.innerHTML  = fmt("cost", "€29.95");
    t2.innerHTML  = fmt("cost", "€24.95");
    t4.innerHTML  = fmt("cost", "€19.95");
    t12.innerHTML = fmt("free");

  } else if (zoneSouthEast.includes(countryCode)) {
    t1.innerHTML  = fmt("cost", "€39.95");
    t2.innerHTML  = fmt("cost", "€34.95");
    t4.innerHTML  = fmt("cost", "€24.95");
    t12.innerHTML = fmt("free");

  } else if (zonePeriphery.includes(countryCode)) {
    t1.innerHTML  = fmt("cost", "€49.95");
    t2.innerHTML  = fmt("cost", "€44.95");
    t4.innerHTML  = fmt("cost", "€34.95");
    t12.innerHTML = fmt("free");

  } else if (countryCode === "NO") {
    t1.innerHTML  = fmt("cost", "435.00 NOK");
    t2.innerHTML  = fmt("cost", "215.00 NOK");
    t4.innerHTML  = fmt("cost", "215.00 NOK");
    t12.innerHTML = fmt("free");

  } else if (countryCode === "CH") {
    t1.innerHTML  = fmt("cost", "18.50 CHF");
    t2.innerHTML  = fmt("cost", "9.50 CHF");
    t4.innerHTML  = fmt("cost", "9.50 CHF");
    t12.innerHTML = fmt("free");

  } else {
    t1.innerHTML  = fmt("cost", "€39.95");
    t2.innerHTML  = fmt("cost", "€19.95");
    t4.innerHTML  = fmt("cost", "€19.95");
    t12.innerHTML = fmt("free");
  }
});
